<div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
  <input pInputText type="text" [(ngModel)]="searchQuery" placeholder="Search by address or postcode" class="tw-flex-1 tw-min-w-0" />
  <button pButton type="button" label="Search" class="tw-w-auto tw-whitespace-nowrap" (click)="searchOnMap()"></button>
</div>
<div class="leaflet-container">
  <div #map style="display: block; height: 320px; width: 100%;"></div>
</div>
